import { Fragment } from "react";
import ContentCard from "../../cards/ContentCard";
import { formatSSN } from "../../../../utils/formatting/ssnFormatter";

function DependentsPreview({ 
  dependents, 
  onEdit, 
  onDelete,
  showActions = true
}) {
  if (!Array.isArray(dependents) || dependents.length === 0) {
    return null;
  }

  const formatRelationship = (relationship) => {
    if (relationship === "qualifying_child") {
      return "Qualifying Child";
    } else if (relationship === "qualifying_relative") {
      return "Qualifying Relative";
    }
    return relationship;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
    } catch (e) {
      return dateString;
    }
  };

  return (
    <Fragment>
      <div className="dependents-list">
        {dependents.map((dependent, index) => (
          <ContentCard key={index}>
            <div className="dependent-card-header">
              <div className="content-card-rows">
                <h4 className="content-card-title">
                  {dependent.firstname} {dependent.lastname}
                </h4>
                <div className="info-row">
                  <span className="info-row-label">SSN / ITIN:</span>
                  <span className="info-row-value">{formatSSN(dependent.ssnItin)}</span>
                </div>
                <div className="info-row">
                  <span className="info-row-label">Date of Birth:</span>
                  <span className="info-row-value">{formatDate(dependent.dateOfBirth)}</span>
                </div>
                <div className="info-row">
                  <span className="info-row-label">Months Lived With You:</span>
                  <span className="info-row-value">{dependent.monthsLivedWith}</span>
                </div>
                <div className="info-row">
                  <span className="info-row-label">Relationship:</span>
                  <span className="info-row-value">{formatRelationship(dependent.relationship)}</span>
                </div>
              </div>
              {showActions && (
                <div className="dependent-card-actions">
                  <button
                    type="button"
                    className="addresspreview-action-btn addresspreview-action-btn-edit"
                    onClick={() => onEdit && onEdit(index)}
                    aria-label="Edit dependent"
                  >
                    <img 
                      src={`${process.env.PUBLIC_URL}/images/icons/basic_edit_blue.svg`} 
                      alt="Edit" 
                      className="addresspreview-icon addresspreview-icon-default"
                    />
                    <img 
                      src={`${process.env.PUBLIC_URL}/images/icons/basic_edit_white.svg`} 
                      alt="Edit" 
                      className="addresspreview-icon addresspreview-icon-hover"
                    />
                  </button>
                  <button
                    type="button"
                    className="addresspreview-action-btn addresspreview-action-btn-delete"
                    onClick={() => onDelete && onDelete(index)}
                    aria-label="Delete dependent"
                  >
                    <img 
                      src={`${process.env.PUBLIC_URL}/images/icons/delete_red.svg`} 
                      alt="Delete" 
                      className="addresspreview-icon addresspreview-icon-default"
                    />
                    <img 
                      src={`${process.env.PUBLIC_URL}/images/icons/delete_white.svg`} 
                      alt="Delete" 
                      className="addresspreview-icon addresspreview-icon-hover"
                    />
                  </button>
                </div>
              )}
            </div>
          </ContentCard>
        ))}
      </div>
    </Fragment>
  );
}

export default DependentsPreview;
